import { type ApiError, toApiError } from '@/api/client'

/** Map API failures to short, user-facing copy for toasts and forms. */
export function apiErrorMessage(error: unknown): string {
  const apiError = toApiError(error)
  switch (apiError.status) {
    case 401:
      return 'Your session expired. Sign in again.'
    case 403:
      return 'You do not have permission to do that.'
    case 404:
      return 'That record was not found.'
    case 409:
      return apiError.message || 'This change conflicts with the current data.'
    case 422:
      return apiError.message || 'The server rejected this change.'
    default:
      return apiError.message || 'Something went wrong.'
  }
}

export function isApiStatus(error: unknown, status: number): error is ApiError {
  return toApiError(error).status === status
}
